"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.quality = exports.isBackendReachable = exports.getWsStatusSelector = exports.getWsReconnectInSelector = exports.getWsReconnectAttemptSelector = exports.getWsErrorSelector = exports.getIsWsTerminated = exports.getIsWsOpenSelector = exports.getIsWsCanLaunchSelector = exports.getIsOnlineSelector = exports.getIsInternetReachableSelector = exports.default = exports.all = void 0;
var _constants = require("./constants");
var all = state => state.network;
exports.all = all;
var isBackendReachable = state => all(state).isBackendReachable;
exports.isBackendReachable = isBackendReachable;
var getWsStatusSelector = state => {
  var _all;
  return (_all = all(state)) === null || _all === void 0 ? void 0 : _all.backendConnectivityStatus;
};
exports.getWsStatusSelector = getWsStatusSelector;
var getWsErrorSelector = state => {
  var _all2;
  return (_all2 = all(state)) === null || _all2 === void 0 ? void 0 : _all2.backendConnectivityError;
};
exports.getWsErrorSelector = getWsErrorSelector;
var getIsWsTerminated = state => {
  var _all3;
  return (_all3 = all(state)) === null || _all3 === void 0 ? void 0 : _all3.isBackendTerminated;
};
exports.getIsWsTerminated = getIsWsTerminated;
var quality = state => all(state).quality;
exports.quality = quality;
var getIsWsOpenSelector = state => getWsStatusSelector(state) === _constants.READY_STATE.OPEN;
exports.getIsWsOpenSelector = getIsWsOpenSelector;
var getIsWsCanLaunchSelector = state => getWsStatusSelector(state) === _constants.READY_STATE.CLOSED && !getIsWsTerminated(state) &&
// last condition to avoid multiple WS in some case
getIsOnlineSelector(state);
exports.getIsWsCanLaunchSelector = getIsWsCanLaunchSelector;
var getIsOnlineSelector = state => {
  var _all4;
  return (_all4 = all(state)) === null || _all4 === void 0 ? void 0 : _all4.isConnected;
};
exports.getIsOnlineSelector = getIsOnlineSelector;
var getIsInternetReachableSelector = state => {
  var _all5;
  return (_all5 = all(state)) === null || _all5 === void 0 ? void 0 : _all5.isInternetReachable;
};
exports.getIsInternetReachableSelector = getIsInternetReachableSelector;
var getWsReconnectInSelector = state => {
  var _all6;
  return (_all6 = all(state)) === null || _all6 === void 0 ? void 0 : _all6.wsReconnectIn;
};
exports.getWsReconnectInSelector = getWsReconnectInSelector;
var getWsReconnectAttemptSelector = state => {
  var _all7;
  return (_all7 = all(state)) === null || _all7 === void 0 ? void 0 : _all7.wsReconnectAttempt;
};
exports.getWsReconnectAttemptSelector = getWsReconnectAttemptSelector;
var _default = exports.default = {
  all,
  quality
};